module.exports = __webpack_public_path__ + "img/luoyangyingtianmen big (1).90eea1e2.jpg";